export default {
  section: 'Inventario',
  listTitle: 'Análisis de inventario',
  captureTitle: 'Captura de inventario',
  trackingTitle: 'Productos a inventariar',
  loading: 'Cargando productos...',
  headers: {
    name: 'Nombre',
    departament: 'Departamento',
    consume: 'Consumo',
    stock: 'Stock semanal',
    quantityArchivedPast: 'Inventario de hace 2 semanas',
    quantityArchived: 'Inventario físico semana anterior',
    weeklyPurchase: 'Compra semanal',
    weeklyDecrease: 'Merma semanal',
    quantityCalculated: 'Inventario Teórico',
    quantityAvailable: {
      buyer: 'Último inventario capturado',
      manager: 'Último inventario capturado',
      chef: 'Último inventario capturado',
      stockmanager: 'Cantidad en inventario'
    },
    difference: 'Diferencia',
    price: 'Precio unitario',
    actions: 'Acciones',
    warehouseLocation: 'Ubicación en almacén',
    lastUpdate: 'Última actualización'
  }
}
